module.exports = __webpack_public_path__ + "img/zwsj_01.48864fb3.png";